<ng-select
  [(ngModel)]="selectedSpecialtyId"
  placeholder="Search for a specialty"
  typeToSearchText="Search Specialties"
  notFoundText="No Specialties Found"
  dropdownPosition="bottom"
  [items]="specialties"
  bindValue="id"
  bindLabel="name"
  [clearable]="false"
  [multiple]="false"
  [searchable]="true"
  [closeOnSelect]="true"
  [clearOnBackspace]="true"
  [virtualScroll]="true"
  [clearSearchOnAdd]="true"
  (ngModelChange)="modelChangeFn($event)"
  id="doctor-specialty"
  name="doctorSpecialty"
  [disabled]="companyId === null"
  [required]="true">
</ng-select>
